module.exports = __webpack_public_path__ + "static/img/2023年历-7.dc2da70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2023年历-7.jpg
// module id = CmUa
// module chunks = 3